import { ROUTE } from 'constant';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { actions } from 'redux/actions';
import { ACTIONS_TYPES } from 'redux/helper';
import Shared from 'screens/shared';
import CreateForm from '../create';

export default withRouter(({ history }) => {
  let { [ACTIONS_TYPES.AUTO_SCALING.GROUP.GET_ALL]: groups = [] } = useSelector((e) => e);
  groups = groups.map(({ id, properties }) => ({ ...properties, id }));

  useEffect(() => {
    actions.autoScaling.group.getAll();
  }, []);

  return (
    <Shared.widgets.Section
      sectionTitle="Groups"
      items={groups}
      itemIcon="expand-arrows-alt"
      setItemTitle={(e) => e.name}
      itemOnClick={(e) => history.push(ROUTE.DASHBOARD.AUTO_SCALING_GROUP.path.replace(':id', e.id))}
      createForm={<CreateForm />}
      createActionType={ACTIONS_TYPES.AUTO_SCALING.GROUP.CREATE}
      tableColumns={['', 'Name']}
    />
  );
});
